var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-repeat"},[_c('h3',{staticClass:"title text-gray-700 font-medium"},[_vm._v("Detail for schedule")]),_c('day-selection',{attrs:{"is-all-day":_vm.isAllDay,"repeat":_vm.repeatOn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }